import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import {
    Accordion,
    AccordionItem,
    AccordionTrigger,
    AccordionContent,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "How long does editorial review take?",
        a: "Most submissions receive a response within 2 business days. Featured and Concierge tiers are reviewed within 48 hours, guaranteed.",
    },
    {
        q: "What kinds of stories do you publish?",
        a: "Openings, awards, new hires, launches, pop-ups, events, fundraisers, leadership announcements, obituaries, and anything that meaningfully impacts the food & hospitality community — with a focus on amplifying underrepresented voices.",
    },
    {
        q: "Can I include images?",
        a: "Yes. You can submit up to 3 thumbnail images plus a hero image (3:2 recommended). High-resolution photography is encouraged.",
    },
    {
        q: "Do you edit my copy?",
        a: "Light editorial polish is included with every submission. Concierge clients get a full rewrite plus two rounds of revisions.",
    },
    {
        q: "Will my release appear in the newsletter?",
        a: "Curated picks land in our monthly newsletter. Featured tier guarantees a dedicated callout in the next issue.",
    },
    {
        q: "Can I update my release after publishing?",
        a: (
            <>
                Yes. Use our{" "}
                <Link
                    to="/contact"
                    className="text-[#E63B26] underline hover:text-[#1B1B1B]"
                    data-testid="faq-contact-link"
                >
                    contact form
                </Link>{" "}
                with the post URL and the change. Corrections are made within
                one business day.
            </>
        ),
    },
    {
        q: "Do you accept embargoed releases?",
        a: "Yes — flag your embargo in the body. We honor embargoes for all tiers.",
    },
    {
        q: "Is there a refund policy?",
        a: "Featured and Concierge are refundable up until editorial review begins. Once we start working on your piece, fees are non-refundable.",
    },
];

export default function FaqsPage() {
    return (
        <div data-testid="faqs-page">
            <PageHero
                eyebrow="Submission FAQs"
                title="Frequently Asked"
                lead="Everything you need to know about getting a story published on BENNE."
                breadcrumbs={[
                    { label: "Home", to: "/" },
                    { label: "Submit a Press Release", to: "/submit-press-release" },
                    { label: "FAQs" },
                ]}
            />
            <div className="px-4 md:px-8 lg:px-12 py-16 max-w-3xl">
                <Accordion type="single" collapsible className="w-full">
                    {FAQS.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`faq-${i}`}
                            className="border-b border-black/10"
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="font-poppins font-semibold text-left text-base md:text-lg py-5 hover:no-underline hover:text-[#E63B26]">
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="font-sofia text-[#1B1B1B]/85 leading-relaxed text-base pb-5">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </div>
    );
}
